import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 300004,
  parentId: 300000,
  name: "DevGuide",
  label: "Template Guide",
  path: "template-guide",
  icon: "form",
  element: Element,
  admin: false,
  hidden: false,
};

export default route;
